package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

@Serializable
internal data class PeriodLogDto(
    @SerialName("periods")
    @Serializable(with = TimestampListSerializer::class)
    val periods: List<Timestamp>
)

internal object TimestampListSerializer : KSerializer<List<Timestamp>> {
    private val listSerializer = ListSerializer(CustomTimestampSerializer)
    override val descriptor: SerialDescriptor = listSerializer.descriptor

    override fun serialize(encoder: Encoder, value: List<Timestamp>) {
        listSerializer.serialize(encoder, value)
    }

    override fun deserialize(decoder: Decoder): List<Timestamp> {
        return listSerializer.deserialize(decoder)
    }
}

